import { render, staticRenderFns } from "./BulkInventoryItemViewModal.vue?vue&type=template&id=6d566d7a"
import script from "./BulkInventoryItemViewModal.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItemViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports